/**
 * Created by Shobhit Jain on 19th May 2020.
 */

import {
  getAgeInYears,
  getDataFromServer,
  getFormattedDateWithoutTimezone
} from '../../../util';
import { dateFormat_DD_MM_YY } from '../../../../util/GlobalConstant';

export class CustomerProfileModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  /**
   * Customer Profile API
   * Do All the Computations Here if possible or The Date Formatting Here Itself.
   * @param payload
   * @returns {Promise<{residential_address: *,
   * occupation: *, gender: *, is_primary: *, city: *,
   * employer_typeof_business: *, document_issue_country: *,
   * employer_name: *, type: *, document_id: *, nationality_code: *,
   * citizenshipCountry: *, division: *, str_count: number,
   * alert_count: number, risk_rating: *, high_risk_party_info: *,
   * segment: *, alert_id: *, party_key: *, birthIncorporationCountry: *,
   * document_type: *, product: *, isStaff: *, citizenship: *,
   * ns_link: boolean, isPep: *, activityDetailsTxnByType: *,
   * contact_number: *, activityDetailsTxnAdditionalInfo: *,
   * domicile_country: *, annual_turnover: *, dob: string,
   * customer_name: *, designation: *, customer_id: *,
   * postal_code: *, residenceOperationCountry: *, age: *}>}
   */
  fetchCustomerProfile = async (payload) => {
    const { customerKey } = payload;

    //Expected URL Regex http(s)://<URL:PORT>/crs/customers/<CustomerKey>
    const {
      customer,
      customerRiskScore,
      latestModelId,
      latestClusterId,
      riskRating,
      riskRatingLabel,
      riskRatingColor,
      isReviewed,
      segmentCode
    } = await getDataFromServer(
      `${this.baseURL}/customers/${customerKey}`,
      this.httpHeaders
    );
    const {
      customerName: partyName,
      customerType,
      age,
      dateOfBirthIncorporation: dobOrIncorporationDate,
      domicileCountry,
      city,
      bankStaffIndicator,
      postalCode,
      segment,
      occupation,
      residentialAddress,
      gender,
      pepInd,
      highRiskPartyInfo,
      employerTypeOfBusiness,
      division,
      idType: documentType,
      nationalityCode,
      contactNumber,
      isPrimary,
      idNumber: documentId,
      activityDetailsTxnAdditionalInfo,
      idCountry: documentIssueCountry,
      employerName,
      activityDetailsTxnByType,
      annualTurnover,
      product,
      customerKey: partyKey,
      birthIncorporationCountry,
      residenceOperationCountry,
      nationality,
      designation,
      customerOnboardDate,
      customerIndustry,
      customerStatus,
      kycReviewDate,
      typeOfBusiness
    } = customer;

    return {
      latestModelId,
      latestClusterId,
      customerStatus,
      typeOfBusiness,
      kycReviewDate,
      customerIndustry,
      customerOnboardDate,
      customerRiskScore,
      customer_id: customerKey,
      partyName,
      riskRating,
      riskRatingLabel,
      riskRatingColor,
      customerType,
      dobOrIncorporationDate: getFormattedDateWithoutTimezone(
        dobOrIncorporationDate,
        dateFormat_DD_MM_YY
      ),
      age: getAgeInYears(dobOrIncorporationDate),
      gender,
      domicileCountry,
      isStaff: bankStaffIndicator,
      city,
      occupation,
      segment,
      postalCode,
      residentialAddress,
      pepInd,
      highRiskPartyInfo,
      employerTypeOfBusiness,
      division,
      documentType,
      nationalityCode,
      contactNumber,
      isPrimary,
      isReviewed,
      documentId,
      activityDetailsTxnAdditionalInfo,
      documentIssueCountry,
      employerName,
      activityDetailsTxnByType,
      annualTurnover,
      product,
      partyKey,
      birthIncorporationCountry,
      residenceOperationCountry,
      nationality,
      designation,
      segmentCode
    };
  };
}
